import React from 'react';
import Skeleton from '../../../components/library/loaders/Skeleton';

const OfficeListSkeletonRow = () => (
    <div className="columns light-grey px-3">
        <div className='column is-3 office-description'>
            <div><span className='is-unselectable'><Skeleton width='100px' /></span></div>
            <div><span className='is-unselectable'><Skeleton width='200px' /></span></div>
        </div>
        <div className='column is-2'>
            <Skeleton width='100px' />
        </div>
        <div className='column'>
            <Skeleton width='50px' />
        </div>
        <div className='column'>
            <Skeleton width='50px' />
        </div>
        <div className='column'>
            <Skeleton width='50px' />
        </div>
        <div className='column is-2'>
            <Skeleton width='50px' />
        </div>
    </div>
)

export default OfficeListSkeletonRow